<span matSnackBarLabel>
  {{ data.message | translate }}
</span>
@if (data.action) {
  <span matSnackBarActions>
    <button class="action" mat-button matSnackBarAction (click)="snackBarRef.dismissWithAction()">
      {{ data.action | translate }}
    </button>
  </span>
}
